'use client';
import { useCallback, useState } from 'react';
export const useActiveControl = ({ initialActive = false } = {}) => {
    const [isActive, setIsActive] = useState(initialActive);
    const open = useCallback(() => setIsActive(true), []);
    const close = useCallback(() => setIsActive(false), []);
    const toggle = useCallback(() => setIsActive((prev) => !prev), []);
    return { isActive, open, close, toggle };
};
